function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
import PropTypes from "prop-types";
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import chroma from 'chroma-js';
import React from 'react';
import { EuiText, EuiFlexGrid, EuiCopy, EuiFlexItem, EuiPanel, EuiHorizontalRule, EuiListGroupItem, useEuiTheme } from '../../../../../src';

// @ts-ignore Importing from JS
import { useJsonVars } from '../_json/_get_json_vars';
export var coreColors = ['euiColorPrimary', 'euiColorAccent', 'euiColorSuccess', 'euiColorWarning', 'euiColorDanger'];
export var coreTextVariants = ['euiColorPrimaryText', 'euiColorAccentText', 'euiColorSuccessText', 'euiColorWarningText', 'euiColorDangerText'];
export var grayColors = ['euiColorEmptyShade', 'euiColorLightestShade', 'euiColorLightShade', 'euiColorMediumShade', 'euiColorDarkShade', 'euiColorDarkestShade', 'euiColorFullShade'];
export var textOnly = ['euiTextColor', 'euiTextSubduedColor', 'euiTitleColor'];
export var textColors = [].concat(textOnly, ['euiColorGhost', 'euiColorInk']);
export var allowedColors = [].concat(coreColors, grayColors);
export var textVariants = [].concat(coreTextVariants, _toConsumableArray(textColors));
import { getContrastRatings } from './_contrast_utilities';
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "twy0ct-ColorSectionSass",
  styles: "grid-template-rows:auto;grid-auto-flow:row;label:ColorSectionSass;"
} : {
  name: "twy0ct-ColorSectionSass",
  styles: "grid-template-rows:auto;grid-auto-flow:row;label:ColorSectionSass;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var ColorSectionSass = function ColorSectionSass(_ref) {
  var color = _ref.color,
    minimumContrast = _ref.minimumContrast,
    showTextVariants = _ref.showTextVariants,
    matchPanelColor = _ref.matchPanelColor;
  var palette = useJsonVars();
  var colorsForContrast = showTextVariants ? textVariants : allowedColors;
  function colorIsCore(color) {
    return coreColors.includes(color) || coreTextVariants.includes(color);
  }
  return ___EmotionJSX(EuiPanel, {
    color: "transparent",
    hasBorder: false,
    paddingSize: matchPanelColor ? 'l' : 'none',
    style: {
      background: matchPanelColor ? palette[color] : undefined
    }
  }, ___EmotionJSX(EuiText, {
    size: "xs"
  }, ___EmotionJSX(EuiFlexGrid, {
    css: _ref2,
    columns: 2,
    direction: "column",
    gutterSize: "s"
  }, showTextVariants && colorIsCore(color) && ___EmotionJSX(ColorsContrastItem, {
    foreground: "".concat(color, "Text"),
    background: 'euiPageBackgroundColor',
    minimumContrast: minimumContrast
  }), colorsForContrast.map(function (color2) {
    if (colorIsCore(color) && colorIsCore(color2)) {
      // i.e. don't render if both are core colors
      return;
    }
    return ___EmotionJSX(ColorsContrastItem, {
      foreground: color2,
      background: color,
      key: color2,
      minimumContrast: minimumContrast
    });
  }))));
};
ColorSectionSass.propTypes = {
  color: PropTypes.string.isRequired,
  minimumContrast: PropTypes.number.isRequired,
  showTextVariants: PropTypes.bool.isRequired,
  matchPanelColor: PropTypes.bool
};
var ColorsContrastItem = ({
  foreground,
  background,
  minimumContrast
}) => {
  const {
    euiTheme
  } = useEuiTheme();
  const palette = useJsonVars();
  const backgroundColor = palette[background];
  const foregroundColor = palette[foreground];
  const backgroundIsBody = background === 'euiPageBackgroundColor';
  const contrast = chroma.contrast(backgroundColor, foregroundColor);
  if (!contrast || contrast < minimumContrast) {
    return <></>;
  }
  const {
    contrastRating,
    contrastRatingBadge
  } = getContrastRatings(contrast, foreground);
  const contrastIsAcceptableToCopy = contrast >= 3;
  const textToCopy = backgroundIsBody ? `color: $${foreground};` : `background-color: $${background};
color: $${foreground};`;
  const beforeMessage = contrastIsAcceptableToCopy ? <small>
      <code>{`$${foreground} / $${background}`}</code>
      <EuiHorizontalRule margin="xs" />
      <kbd>Click</kbd> to copy SASS configuration
    </small> : <small>
      Cannot copy configuration because the contrast is not acceptable
    </small>;
  return <EuiFlexItem className="eui-textCenter">
      <EuiCopy anchorClassName="eui-displayBlock" title={<span>
            {contrastRatingBadge} Contrast is {contrast.toFixed(1)}
          </span>} beforeMessage={beforeMessage} afterMessage={<small>Copied!</small>} textToCopy={textToCopy}>
        {copy => <EuiListGroupItem iconType={contrastRating} size="s" onClick={contrastIsAcceptableToCopy ? copy : undefined} aria-label={contrastIsAcceptableToCopy ? 'Click to copy Sass configurations' : undefined} style={{
        backgroundColor: backgroundColor,
        color: foregroundColor,
        borderRadius: euiTheme.border.radius.medium
      }}
      // @ts-expect-error - this isn't a valid color type, we mostly just want to disable the default EuiListGroupItem button color from being rendered since we're setting our own via `style`
      color="inherit" label={sanitizeColorName(foreground)} />}
      </EuiCopy>
    </EuiFlexItem>;
};
ColorsContrastItem.propTypes = {
  foreground: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  minimumContrast: PropTypes.number.isRequired
};
function sanitizeColorName(color) {
  const string = color.split('euiColor').pop();
  // Make sure `eui` is removed if it wasnt the full `euiColor` string
  const noEui = string?.split('eui').pop();
  // Add space between caplital letters
  return noEui?.replace(/([A-Z])/g, ' $1').trim();
}
try {
  ColorSectionSass.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/color/_contrast_sass.tsx',
    description: '',
    displayName: 'ColorSectionSass',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: '',
        name: 'color',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      minimumContrast: {
        defaultValue: null,
        description: '',
        name: 'minimumContrast',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      showTextVariants: {
        defaultValue: null,
        description: '',
        name: 'showTextVariants',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      matchPanelColor: {
        defaultValue: null,
        description: '',
        name: 'matchPanelColor',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}